import TemplateView from "../TemplateView";
import {getStatusClassByType} from "../workflowStatus/utils";
import {getColorClassById} from "./utils";

export default class WorkFlowStatusIcon extends TemplateView {

    constructor($containerEl, {
        type,
        colorId,
        additionalClass = ''
    }) {
        super($containerEl);

        this.typeClass = getStatusClassByType(type);
        this.colorClass = getColorClassById(colorId);

        this.params = {
            additionalClass,
            clazz: 'workflowStatusIcon'
        }

        this.state = {
            type: type,
            colorId: colorId
        }

        this.onStateChanged(() => {
            this._updateClasses()
        });
    }

    _updateClasses() {
        const classes = [
            this.params.clazz,
            this.params.additionalClass,
            getStatusClassByType(this.state.type),
            getColorClassById(this.state.colorId)
        ]
        this.$el
            .removeClass()
            .addClass(classes.join(' '))
    }

    templateHtml() {
        return "<div class='workflowStatusIcon <%-typeClass%> <%-colorClass%>'></div>";
    }

    afterRender() {
        this._updateClasses()
    }
}


// WEBPACK FOOTER //
// ./web/js/workflowStatus/WorkflowStatusIcon.js